module.exports = __webpack_public_path__ + "img/4.3159dbf5.jpg";